import * as React from 'react';

const SvgFilledLike = (props) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 13.9993H5.33331V5.33268L9.99998 0.666016L10.8333 1.49935C10.9111 1.57713 10.975 1.68268 11.025 1.81602C11.075 1.94935 11.1 2.07713 11.1 2.19935V2.43268L10.3666 5.33268H14C14.3555 5.33268 14.6666 5.46602 14.9333 5.73268C15.2 5.99935 15.3333 6.31046 15.3333 6.66602V7.99935C15.3333 8.07713 15.325 8.16046 15.3083 8.24935C15.2916 8.33824 15.2666 8.42157 15.2333 8.49935L13.2333 13.1993C13.1333 13.4216 12.9666 13.6105 12.7333 13.766C12.5 13.9216 12.2555 13.9993 12 13.9993ZM3.99998 5.33268V13.9993H1.33331V5.33268H3.99998Z" fill="#5E6C84" />
    </svg>

)

export default SvgFilledLike;